import styled from '@emotion/styled';
import { Badge } from 'antd';

export default styled(Badge)`
  ${({ size }) => (size === 'small' ? 'sup { line-height: 15px !important; }' : '')}
`;
